/**
 * SupportTabNav - 공지사항 / FAQ / 문의하기 탭 네비게이션
 */
import React from 'react';
import { Box, Button } from '@mui/material';
import { useChannelPath } from '../../../contexts/ChannelContext';

interface SupportTabNavProps {
  active: 'notices' | 'faq';
}

const tabs = [
  { key: 'notices' as const, label: '공지사항', path: '/notices' },
  { key: 'faq' as const, label: 'FAQ', path: '/faq' },
];

const SupportTabNav: React.FC<SupportTabNavProps> = ({ active }) => {
  const channelPath = useChannelPath();

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      gap: { xs: 1, md: 1.5 },
      py: { xs: 3, md: 4 },
    }}>
      {tabs.map((tab) => {
        const isActive = active === tab.key;
        return (
          <Button
            key={tab.key}
            href={channelPath(tab.path)}
            variant={isActive ? 'contained' : 'outlined'}
            sx={{
              minWidth: { xs: 100, md: 140 },
              py: { xs: 1, md: 1.3 },
              px: { xs: 2.5, md: 4 },
              borderRadius: 50,
              fontWeight: 700,
              fontSize: { xs: '0.85rem', md: '0.95rem' },
              textTransform: 'none',
              ...(isActive
                ? {
                    background: '#0f172a',
                    color: '#fff',
                    boxShadow: '0 4px 16px rgba(15, 23, 42, 0.2)',
                    '&:hover': { background: '#1e293b' },
                  }
                : {
                    borderColor: '#d1d5db',
                    color: '#64748b',
                    background: '#fff',
                    '&:hover': { borderColor: '#94a3b8', background: '#f8fafc' },
                  }),
              transition: 'all 0.2s ease',
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </Box>
  );
};

export default SupportTabNav;
